export const AppName = import.meta.env.VITE_NAME;
export const BaseUrl = import.meta.env.BASE_URL;
export const ApiUrl = import.meta.env.VITE_API_URL;
